import { List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { useUpdateMany, useModal } from "@refinedev/core";
import { useNavigate } from "react-router-dom";

import { GridRowSelectionModel } from "@mui/x-data-grid";

import { ICenter } from "./interfaces";
import { MenuItem, TextField, Button, Modal, Box } from "@mui/material";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { centersColumns } from "./components/centersColumns";
import { centersSearchFields } from "./components/centersSearchFields";

export const CenterList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<ICenter>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }]
            }
        });

    const navigate = useNavigate();
    const { visible, show, close } = useModal();

    const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);
    const [kindOfForMultipleUpdate, setKindOfForMultipleUpdate] = React.useState<string>("");

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    const { mutate } = useUpdateMany<ICenter>();

    const updateSelectedItems = (value: any) => {
        if (value === "") {
            alert("종류를 선택해주세요.");
            return;
        }
        mutate(
            {
                resource: `centers`,
                values: {
                    kindOf: value,
                },
                ids: rowSelectionModel.map((id) => id.toString())
            },
            {
                onSuccess: () => {
                    setRowSelectionModel([]);
                    navigate(0);
                }
            }
        )
    }

    const hasSelected = rowSelectionModel.length > 0;

    return (
        <List
            breadcrumb={<></>}
            headerButtons={({ defaultButtons }) => (
                <>
                {defaultButtons}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => show()}
                    disabled={!hasSelected}
                >
                    한번에 수정하기
                </Button>
                </>
            )}
        >
            <ListPageHeader
                count={lastRowCountRef.current}
                description="아이러빗에 등록된 시설 목록"
            />

            <SearchToolbar
                fields={centersSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={centersColumns}
                getRowShowPath={(row) => `/centers/show/${row.id}`}
                isError={tableQueryResult.isError}
                errorMessage="시설 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 시설이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setRowSelectionModel(model)}
                rowSelectionModel={rowSelectionModel}
            />

            <Modal open={visible} onClose={() => { setKindOfForMultipleUpdate(""); close(); }}>
                <Box sx={modalStyle}>
                    {/* <form onSubmit={() => updateSelectedItems()}> */}
                        <TextField sx={{ width: '100%', marginBottom: '20px' }}
                            id="kindOf"
                            label="종류"
                            name="kindOf"
                            select
                            variant="outlined"
                            required
                            InputLabelProps={{ shrink: true }}
                            value={kindOfForMultipleUpdate}
                            onChange={e => setKindOfForMultipleUpdate(e.target.value)}
                        >
                            <MenuItem value={"ChildHouse"}>어린이집</MenuItem>
                            <MenuItem value={"Kindergarten"}>유치원</MenuItem>
                            <MenuItem value={"Dementia"}>치매</MenuItem>
                            <MenuItem value={"IDisabled"}>지적장애</MenuItem>
                            <MenuItem value={"기타"}>기타</MenuItem>
                        </TextField>
                        <Button variant="contained" onClick={() => updateSelectedItems(kindOfForMultipleUpdate)}>확인</Button>
                    {/* </form> */}
                </Box>
            </Modal>
        </List>
    );
};

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
